export default __webpack_public_path__ + "static/media/122143.8c6dd065.png";